module.exports = __webpack_public_path__ + "img/gvov.3564652c.png";